import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { FormsModule } from '@angular/forms';

import { ConvertDirective } from '@core/converter';

export type ConfirmBetDialogClosedEvent = {
  confirmBet: boolean;
  neverAskAgain: boolean;
};

@Component({
    selector: 'ui-confirm-bet',
    imports: [ConvertDirective, FormsModule],
    templateUrl: './confirm-bet.dialog.html',
    styleUrl: './confirm-bet.dialog.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmBetDialog {
  public readonly data = inject<number>(DIALOG_DATA);
  public readonly dialogRef = inject(DialogRef);

  public neverAskAgain = false;

  closeModal(confirmBet = false): void {
    this.dialogRef.close({
      confirmBet,
      neverAskAgain: this.neverAskAgain
    });
  }
}
